import React, { useState, useEffect } from "react";
import { ChevronLeft } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import apilink from "../globals/Baseurls";
import axios from "axios";
import { Squares } from "react-activity";
import "react-activity/dist/library.css";

const MoreContributions = () => {

  const navigate = useNavigate();
  const [gatherings, setGatherings] = React.useState([]);
  const [postinginfo, setPostinginfo] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [info, setInfo] = useState({
    familycode: "",
    id: "",
    enddate: "",
    theme: "",
    notes: "",
  });

  const [updating, setUpdating] = useState(false);

  const editRecord = async (id) => {
    let result = gatherings.find((obj) => obj.id == id);

    setInfo({
      ...info,
      id: result.id,
      enddate: result.enddate,
      theme: result.theme,
      notes: result.notes,
    });

    setUpdating(true);
  };

  const refetchData = async () => {
    const storedUser = await JSON.parse(
      localStorage.getItem("userSessionData")
    );

    setPostinginfo(false);
    setUpdating(false);
    setDeleting(false);

    setInfo({
      ...info,
      familycode: storedUser.familycode,
      id: "",
      enddate: "",
      theme: "",
      notes: "",
    });

    //Today
    const baseUrl = apilink.link;
    await axios
      .get(`${baseUrl}/family/admin/contris/${storedUser.familycode}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })

      .then((response) => {
        if (response.data.message == "Successfull") {
          setGatherings(response.data.records);
        }
      })
      .catch((error) => {
        console.log(error.response.data.message);
      });
  };

  const handleDelete = async () => {
    if (info.id === "") {
        toast.warn("Failed. Select record first", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      }
      setDeleting(true);

      const baseUrl = apilink.link;
  
      console.log(info);
      axios
        .get(`${baseUrl}/family/admin/deletecontri/${info.id}`, info)
        .then((response) => {
          if (response.data.message == "Saving successfull") {
            toast.success("Deletion successfull", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            refetchData();
            return;
          } else {
            toast.warn(response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setDeleting(false);
            return;
          }
        })
        .catch((err) => {
          console.log(err);
          console.log("Error creating fetching", err);
        });
  }
  const handleInfo = async () => {
    if (info.theme === "") {
      toast.warn("Failed. Fill in the gathering theme", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (info.enddate === "") {
      toast.warn("Failed. Select the gathering date", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (info.starttime === "") {
      toast.warn("Failed. Select the gathering start time", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (info.venue === "") {
      toast.warn("Failed. Type in the gathering venue", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    setPostinginfo(true);

    const baseUrl = apilink.link;

    let url = "contri";
    if (updating) {
      url = "updatecontri";
    }

    console.log(info);
    axios
      .post(`${baseUrl}/family/admin/${url}`, info)
      .then((response) => {
        if (response.data.message == "Saving successfull") {
          toast.success("Saving successfull", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          refetchData();
          return;
        } else {
          toast.warn(response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setPostinginfo(false);
          return;
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("Error creating post");
      });
  };

  useEffect(() => {
    const getAsyncData = async () => {
      const storedUser = await JSON.parse(
        localStorage.getItem("userSessionData")
      );
      setInfo({
        familycode: storedUser.familycode,
        id: "",
        enddate: "",
        theme: "",
        notes: "",
      });

      //Today
      const baseUrl = apilink.link;
      await axios
        .get(`${baseUrl}/family/admin/contris/${storedUser.familycode}`, {
          headers: {
            "Content-Type": "application/json",
          },
        })

        .then((response) => {
          if (response.data.message == "Successfull") {
            setGatherings(response.data.records);
          }
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    };
    getAsyncData();
  }, []);
  return (
    <div>
      <div
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#779d38",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
        }}
      >
        <h4 onClick={()=>navigate("/admin/more")} style={{ fontFamily: "Open Sans", fontSize: 17 }}>
          <ChevronLeft size={20} style={{ color: "#ffffff" }} />
        </h4>
        <h4 style={{ fontFamily: "Open Sans", fontSize: 17, color: "#ffffff" }}>
          <b>More /</b> Contributions
        </h4>
      </div>
      <div
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "17px",
        }}
      >
        <div
          style={{
            alignItems: "center",
            paddingInline: "10px",
            marginTop: "10px",
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "#779d3820",
            height: "50px",
            marginBottom: "40px",
            width: "100%",
            borderRadius: "5px",
          }}
        >
          <h4
            style={{ fontFamily: "Open Sans", fontSize: 20, color: "#779d38" }}
          >
            Contributions Form - {updating ? "Update" : "Save"}
          </h4>
        </div>

        <div className="row">
          <div className="col-lg-3">
            <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
            Contribution Name Or Theme
            </label>
            <br />
            <input
              type="text"
              style={{
                width: "100%",
                borderWidth: 1,
                borderColor: "#779d38",
                borderRadius: 5,
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                marginBottom: "10px",
              }}
              value={info.theme}
              onChange={(e) => {
                setInfo({ ...info, theme: e.target.value });
              }}
            />
          </div>
          <div className="col-lg-3">
            <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
            Contribution End Day
            </label>
            <br />
            <input
              type="date"
              style={{
                width: "100%",
                borderWidth: 1,
                borderColor: "#779d38",
                borderRadius: 5,
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                marginBottom: "10px",
              }}
              value={info.enddate}
              onChange={(e) => {
                setInfo({ ...info, enddate: e.target.value });
              }}
            />
          </div>
          <div className="col-lg-6">
          <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
            Contributions Notes To Members - Optional
            </label>
            <br />
            <textarea
              style={{
                width: "100%",
                height: "auto",
                borderWidth: 1,
                borderColor: "#779d38",
                borderRadius: 5,
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                marginBottom: "10px",
              }}
              value={info.notes}
              onChange={(e) => {
                setInfo({ ...info, notes: e.target.value });
              }}
            />
          </div>
       
        </div>
        <div className="row">
          <div className="col-lg-9">
           
          </div>

          <div className="col-lg-3">
            <button
              onClick={() => handleInfo()}
              style={{
                width: "100%",
                backgroundColor: "#779d38",
                borderRadius: 5,
                border: "none",
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                marginTop: 23,
                color: "white",
              }}
            >
              {postinginfo === false && <> {updating ? "Update" : "Save"}</>}
              {postinginfo && (
                <>
                  <Squares />
                </>
              )}
            </button>

            {updating && (
              <div className="row">
                <div className="col-lg-6">
                  <button
                    onClick={() => refetchData()}
                    style={{
                      width: "100%",
                      backgroundColor: "orange",
                      borderRadius: 5,
                      border: "none",
                      height: 50,
                      fontFamily: "Open Sans",
                      fontSize: 14,
                      marginTop: 23,
                      color: "white",
                    }}
                  >
                    Clear
                  </button>
                </div>
                <div className="col-lg-6">
                  <button
                    onClick={() => handleDelete()}
                    style={{
                      width: "100%",
                      backgroundColor: "red",
                      borderRadius: 5,
                      border: "none",
                      height: 50,
                      fontFamily: "Open Sans",
                      fontSize: 14,
                      marginTop: 23,
                      color: "white",
                    }}
                  >
                    {deleting === false && <> {"Delete"}</>}
                    {deleting && (
                      <>
                        <Squares />
                      </>
                    )}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Close Birthdays*/}
      <div
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "17px",
        }}
      >
        <div
          style={{
            alignItems: "center",
            paddingInline: "10px",
            marginTop: "10px",
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "#779d3820",
            height: "50px",
            marginBottom: "40px",
            width: "100%",
            borderRadius: "5px",
          }}
        >
          <h4
            style={{ fontFamily: "Open Sans", fontSize: 20, color: "#779d38" }}
          >
            Saved Contributions ({gatherings.length})
          </h4>
          <br></br>
          <label style={{ color: "red" }}>
            Click the record information to get edit or delete options
          </label>
        </div>
        {gatherings.map((record) => (
          <div
            key={record.id}
            onClick={() => editRecord(record.id)}
            style={{ flexDirection: "column", marginBottom: "30px" }}
          >
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h6 style={{ fontFamily: "Open Sans", fontWeight: "bold" }}>
                  {record.theme}
                </h6>
                <h6 style={{ fontFamily: "Open Sans" }}>
                  <b>Notes:</b> {record.notes == null ? "---" : record.notes}
                </h6>
              </div>
              <div>
                <span className="float-end" style={{ fontFamily: "Open Sans" }}>
                  <b>End Date: </b> {record.enddate}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default MoreContributions;
